import { useTranslation } from 'react-i18next';
import { ProfileMenu } from '@/components/ProfileMenu';
import { useCurrentUserContext } from '@/contexts';
import { useAuthModal } from '@/features/magic/components/AuthModal';
import { type MenuButtonProps, Button } from '@/ui';

type Props = {
  isCompact?: boolean;
  buttonProps?: MenuButtonProps;
};

export const AuthRightColumn = ({ isCompact, buttonProps }: Props) => {
  const { isLoading, isAuthenticated } = useCurrentUserContext();
  const { open: openAuthModal } = useAuthModal();
  const { t } = useTranslation('auth');

  if (isLoading) return null;

  if (isAuthenticated) {
    return <ProfileMenu buttonProps={buttonProps} isCompact={isCompact} />;
  }

  return (
    <>
      <Button
        colorScheme="dark"
        data-testid="nav-login"
        mr="2"
        size="sm"
        variant="link"
        onClick={() => openAuthModal()}
      >
        {t('sign_in')}
      </Button>
      <Button colorScheme="dark" size="sm" onClick={() => openAuthModal()}>
        {t('sign_up')}
      </Button>
    </>
  );
};
